import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5c00e0a4&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=5c00e0a4&lang=scss&scoped=true"
import style1 from "./Index.vue?vue&type=style&index=1&id=5c00e0a4&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c00e0a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5c00e0a4')) {
      api.createRecord('5c00e0a4', component.options)
    } else {
      api.reload('5c00e0a4', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=5c00e0a4&scoped=true", function () {
      api.rerender('5c00e0a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinancialManagementOld/Index.vue"
export default component.exports